import classNames from 'classnames';
import React from 'react';

type Props = {
  backgroundColor?: string;
  borderColor?: string;
  children: React.ReactNode;
  className?: string;
};

const Avatar = ({ backgroundColor, children, className, borderColor }: Props) => (
  <div className={classNames('avatar', className)} style={{ backgroundColor, borderColor }} data-private data-dd-privacy="mask">
    {children}
  </div>
);

export default Avatar;
